import { useLayoutEffect, useState, type RefObject } from "react"

export function useCompactAudioTrackInset(
  root: RefObject<HTMLDivElement | null>,
  enabled: boolean,
  durationMs: number,
  domainMs: number,
) {
  const [inset, setInset] = useState<{
    leftPx: number
    rightPx: number
    tailPx: number
  } | null>(null)
  useLayoutEffect(() => {
    const container = root.current
    const well = container?.querySelector<HTMLElement>(
      "[data-audio-waveform-well]",
    )
    if (!enabled || !container || !well) {
      return
    }
    const refresh = () => {
      const outer = container.getBoundingClientRect()
      const rect = well.getBoundingClientRect()
      if (rect.width <= 0) {
        return
      }
      const tailPx =
        (rect.width * Math.max(0, domainMs - durationMs)) / domainMs
      const leftPx = rect.left - outer.left - container.clientLeft
      const rightPx = outer.right - rect.right - container.clientLeft + tailPx
      setInset((current) =>
        current?.leftPx === leftPx &&
        current.rightPx === rightPx &&
        current.tailPx === tailPx
          ? current
          : { leftPx, rightPx, tailPx },
      )
    }
    refresh()
    const observer = new ResizeObserver(refresh)
    observer.observe(container)
    observer.observe(well)
    return () => observer.disconnect()
  }, [root, enabled, durationMs, domainMs])
  return enabled ? inset : null
}
